import { Pipe, PipeTransform } from '@angular/core';
import { Location } from '@angular/common';

@Pipe({ name: 'embededUrl'})
export class EmbededUrlPipe implements PipeTransform {

  constructor(private location: Location) {
  }

  private viewInOfficeLive(url) {
    return url.toLowerCase().includes('.ppt');
  }

  private embededUrl(url) {
    let embededUrl = null;
    if (url.toLowerCase().includes('.ppt')) {
      embededUrl = 'https://view.officeapps.live.com/op/embed.aspx?src=' + url;
    }

    if (url.toLowerCase().includes('prezi.com')) {
      const normalizedUrl = this.normalizeURL(url);
      embededUrl = normalizedUrl + 'embed';
    }
    return embededUrl;
  }

  private normalizeURL(url) {
    return url.endsWith('/') ? url : url + '/';
  }

  // Force URL to start with https
  private forceHttpsURL(url) {
    if (url.indexOf('http://') === 0) {
      url = url.replace('http', 'https');
    }
    return url;
  }

  transform(message: any, ...args): string {
    // let url = '../assets/placeholder-html.html';
    let url = this.location.prepareExternalUrl('assets/placeholder-html.html');

    if (message.field_mt_presentation_url && message.field_mt_presentation_url.length > 0) {
      const value = message.field_mt_presentation_url[0].value;
      const urlOverHttps = this.forceHttpsURL(value);
      url = this.embededUrl(urlOverHttps) || urlOverHttps;
      return url;
    }

    if (message.field_mt_ses_files && message.field_mt_ses_files.length > 0) {
      const value = message.field_mt_ses_files[0].url;
      const urlOverHttps = this.forceHttpsURL(value);
      url = this.embededUrl(urlOverHttps) ||
              urlOverHttps + '#view=fit&page=1&scrollbar=0&toolbar=0&navpanes=0';
      return url;
    }

    return url;
  }
}
